import { render, staticRenderFns } from "./CollapsedRequestsChart.vue?vue&type=template&id=482ac149&"
import script from "./CollapsedRequestsChart.vue?vue&type=script&lang=ts&"
export * from "./CollapsedRequestsChart.vue?vue&type=script&lang=ts&"
import style0 from "./CollapsedRequestsChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports